import React from "react";

export default function Slogan() {
  return (
    <div className="w-full lg:px-0 px-4">
      <div className="block w-full lg:w-1080px mx-auto">
        <h3
          className="
          h4-24-bold lg:h2-44-bold
          text-center lg:text-left
          text-dark-major
          "
        >
          Credit generation on blockchain
        </h3>
        <p className="p-16-normal lg:p-18-normal text-center text-dark-minor lg:text-left w-full lg:w-480px mt-4">
          Collaboration behaviors stored on-chain and credit built by the
          objective and subjective elements.
        </p>
      </div>
    </div>
  );
}
